<template>
  <div class="percentage-complete">
    <div class="percentage-header">
      <span class="percentage-title">{{ title }}</span>
      <span class="percentage-value" :style="{ color: activeColor }">{{ percent }}% complete</span>
    </div>
    <div class="percentage-track">
      <div
        class="percentage-bar"
        :style="{ width: clampedPercent + '%', backgroundColor: activeColor }"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  percent: {
    type: Number,
    required: true,
  },
  color: {
    type: String,
    default: '#a0c41c',
  },
  completeColor: {
    type: String,
    default: '#a0c41c',
  },
});

const clampedPercent = computed(() => {
  return Math.min(100, Math.max(0, props.percent));
});

const activeColor = computed(() => {
  return props.percent >= 100 ? props.completeColor : props.color;
});
</script>

<style scoped lang="scss">
.percentage-complete {
  width: 100%;
  border-radius: 3px;
}

.percentage-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.percentage-title {
  font-size: 14px;
}

.percentage-value {
  font-size: 14px;
  color: #666;
}

.percentage-track {
  width: 100%;
  height: 8px;
  background: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}

.percentage-bar {
  height: 100%;
  border-radius: 4px;
  transition: width 0.3s ease;
}
</style>
